package pl.michal_cyran.brand_hub.subpages.main.hero

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.autoLength
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.AnimationTimingFunction.Companion.EaseIn
import org.jetbrains.compose.web.css.AnimationTimingFunction.Companion.EaseOut
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s
import pl.michal_cyran.brand_hub.CardStyle
import pl.michal_cyran.brand_hub.HeroVisualLogoStyle
import pl.michal_cyran.brand_hub.HeroVisualTagStyle
import pl.michal_cyran.brand_hub.HeroVisualTagsStyle
import pl.michal_cyran.brand_hub.components.widgets.VisibilityAware
import pl.michal_cyran.brand_hub.toSitePalette

@Composable
fun HeroVisual() {
    val cm = ColorMode.current.toSitePalette()

    VisibilityAware(
        modifier = CardStyle.toModifier()
            .maxWidth(400.px)
            .margin(0.px, autoLength)
    ) { isVisible ->
        Column(
            modifier = Modifier
                .opacity(if (isVisible) 1 else 0)
                .transform {
                    translateY(if (isVisible) 0.px else 24.px)
                    scale(if (isVisible) 1.0 else 0.94)
                }
                .transition(
                    Transition.of("opacity", 0.6.s, EaseOut, 150.ms),
                    Transition.of("transform", 0.6.s, EaseOut, 150.ms)
                ),
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            Box(
                HeroVisualLogoStyle.toModifier()
                    .transform { scale(if (isVisible) 1.0 else 0.5) }
                    .transition(
                        Transition.of("transform", 0.4.s, EaseIn, 350.ms)
                    )
            ) {
                SpanText(
                    "M",
                    modifier = Modifier
                        .fontSize(48.px)
                        .fontWeight(FontWeight.Bold)
                )
            }
            Column(
                horizontalAlignment = Alignment.CenterHorizontally,
                modifier = Modifier
                    .textAlign(TextAlign.Center)
                    .opacity(if (isVisible) 1 else 0)
                    .transform { translateY(if (isVisible) 0.px else 10.px) }
                    .transition(
                        Transition.of("opacity", 0.4.s, EaseOut, 450.ms),
                        Transition.of("transform", 0.4.s, EaseOut, 450.ms)
                    )
            ) {
                SpanText(
                    "Michał Cyran",
                    modifier = Modifier
                        .fontSize(24.px)
                        .fontWeight(FontWeight.Bold)
                        .color(cm.textHeading)
                )
                SpanText(
                    "Twój przewodnik po matematyce",
                    modifier = Modifier.color(cm.textMuted)
                )
            }
            Row(
                HeroVisualTagsStyle.toModifier()
                    .opacity(if (isVisible) 1 else 0)
                    .transition(
                        Transition.of("opacity", 0.4.s, EaseOut, 600.ms)
                    )
            ) {
                listOf("Matura", "Egzamin ósmoklasisty", "Wsparcie w lekcjach").forEachIndexed { i, tag ->
                    SpanText(
                        tag,
                        modifier = HeroVisualTagStyle.toModifier()
                            .opacity(if (isVisible) 1 else 0)
                            .transform { scale(if (isVisible) 1.0 else 0.7) }
                            .transition(
                                Transition.of("opacity", 0.3.s, EaseOut, (600 + i * 100).ms),
                                Transition.of("transform", 0.3.s, EaseIn, (600 + i * 100).ms)
                            )
                    )
                }
            }
        }
    }
}